import React, { useState } from "react";
import MultiSelect from "react-multi-select-component";
import ControlFeedback from "./ControlFeedback";
import { SelectListControlProps, SelectListOption, UdfOption } from "./Types";

const MultiSelectControl: React.FC<SelectListControlProps> = ({ name, value, disabled, width, validationResults, onChange, onBlur, options }) => {
    const [isMenuOpen, setMenuOpen] = useState(false);
    const [hasFocus, setFocus] = useState(false);

    function onControlChange(selectedOptions: SelectListOption[]) {
        let selected: any = [];
        selectedOptions.forEach(function (option: SelectListOption) {
            selected.push(option.value);
        });

        onChange(selected);

        if (onBlur)
            onBlur();
    }

    //console.log(options);
    let v: any = [];
    let allLabels: string[] = []
    if (options && options.length > 0) {
        options.forEach(function (option: SelectListOption | UdfOption<string>) {
            allLabels.push(option.label);
            if (value != undefined) {
                value.forEach(function (val: number | string) {
                    if (option.value == val)
                        v.push(option);
                })
            }
        });
    }

    let isValid = validationResults && validationResults.length > 0 ? false : true

    let className = "form-control select " + (isMenuOpen ? "menu-open" : (hasFocus ? "menu-focus" : "menu-closed"));

    if (width === undefined)
        width = '100%';

    let controlOptions: SelectListOption[] | UdfOption<string>[] = []
    if (options)
        controlOptions = options

    return (
        <div style={{ width: width }}>
            <MultiSelect
                className={className}
                value={v}
                disabled={disabled}
                options={controlOptions}
                onChange={onControlChange}
                
                overrideStrings={
                    {
                        "allItemsAreSelected": allLabels.join(', '),
                        "clearSearch": "Clear Search",
                        "clearSelected": "Clear Selected",
                        "noOptions": "No options",
                        "search": "Search",
                        "selectAll": "Select All",
                        "selectAllFiltered": "Select All (Filtered)",
                        "selectSomeItems": "-- Select",
                        "create": "Create",
                    }}
                labelledBy={"Select"}
            />
            <ControlFeedback isValid={isValid} validationResults={validationResults}></ControlFeedback>
        </div>
    );
}
export default MultiSelectControl;
